import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type React from 'react'
import { useSelector } from 'react-redux'

import { PLAN_FREE } from '@/constants/userSubscriptionPlans'
import { useProjectAccess } from '@/hooks'
import { PROJECT_TITLE_PERMISSION } from '@/permissions/project/definitions'
import { AvatarItem, DefaultIconButton, DefaultItem } from './components'

export const ProjectIconMenu: React.FC = () => {
  const avatar = useSelector(migrationProjectSelector.getProjectAvatar)

  const defaultIcon = !avatar

  const { hasAccess } = useProjectAccess(PROJECT_TITLE_PERMISSION.CHANGE_LOGO)
  const canEdit = useSelector(migrationProjectSelector.getProjectAccessCanEdit)

  const ownerPlan = useSelector(migrationProjectSelector.getProjectOwnerPlan)

  const freeOwner = ownerPlan === PLAN_FREE
  const disabled = !(hasAccess || canEdit)

  return (
    <>
      {defaultIcon && <DefaultItem />}
      {!defaultIcon && <DefaultIconButton />}
      {avatar && <AvatarItem src={avatar} />}
      <DropdownMenu.Divider />
      {!freeOwner && (
        <DropdownMenu.Button
          disabled={disabled}
          id="upload"
          preventClose
          title="Upload new..."
        />
      )}
      {freeOwner && (
        <DropdownMenu.BadgedButton
          id="upgrade"
          type="pro"
          title="Upload new..."
        />
      )}
    </>
  )
}
